module.exports = __webpack_public_path__ + "static/media/create_audio@2x.e090cf59.png";